import React from "react";

import ErrorIcon from '../../assets/images/error_rounded.png'

const backdropStyles = {
  display: 'none',
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  background: 'rgba(0, 0, 0, 0.5)',
  zIndex: 999,
};

const ModalError = ({ message }) => {
  return (
    <div>
      <div
        id="backdrop-error"
        style={backdropStyles}
      />
      <div className="modal fade success-modal" id="submit-error" tabIndex="-1" style={{ display: 'none', opacity: 1 }}>
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div className="confirm-title" style={{ textAlign: 'center', padding: '56px 40px 0px 40px' }}>
                <img className="img-fluid confirm-offer w-50" src={ErrorIcon} alt="error-address" />
                <div
                  className="mt-5"
                  style={{
                    textAlign: 'center',
                    fontWeight: 'bold',
                    fontSize: '18px'
                  }}
                >
                  { message }
                </div>
              </div>

              <div
                className="filter-footer mb-3"
              >
                <button
                  className="btn theme-btn apply-btn w-100"
                  onClick={() => {
                    document.getElementById('submit-error').style.display = 'none';
                    document.getElementById('backdrop-error').style.display = 'none';
                  }}
                >
                  Try Again
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalError;
